import { AdresseFavorite } from "../types/models/adresse-favorite";
import { AdresseFavoriteForm } from "../types/forms/adresse-favorite-form";

export class AdressesFavoritesService {
  constructor(
    private readonly apiUrl: string,
  ) {}

  public getFavorites = async (
    idClient: number,
  ): Promise<AdresseFavorite[]> => {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/clients/${idClient}/adresse-favorite`,
        {
          method: "GET",
          cache: "no-store",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur API: ${resultat.status}`);
      }

      return await resultat.json();
    } catch (error) {
      console.error("Erreur lors de la récupération des cours:", error);
      throw error;
    }
  };

  public addFavorite = async (
    idClient: number,
    adresse: AdresseFavoriteForm,
  ) => {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/clients/${idClient}/adresse-favorite`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(adresse),
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur API: ${resultat.status}`);
      }
    } catch (error) {
      console.error("Erreur lors de la création de l'adresse favorite:", error);
      throw error;
    }
  };

  public deleteFavorite = async (idClient: number, idAdresse: number) => {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/clients/${idClient}/adresse-favorite/${idAdresse}`,
        {
          method: "DELETE",
          headers: {
          },
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur API: ${resultat.status}`);
      }
    } catch (error) {
      console.error(
        "Erreur lors de la suppression de l'adresse favorite:",
        error,
      );
      throw error;
    }
  };
}
